export const model = {
    id: null,
    name: "",
    is_report: "",
    is_conclusion: "",
    is_register: "",
    created_at: '',
    updated_at: ''
};
